import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-007e27e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "popup" }
const _hoisted_3 = { class: "popup-content" }
const _hoisted_4 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-spinner" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-2" }, null, -1))
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-tip" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorDisplay = _resolveComponent("ErrorDisplay")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_VSpacer = _resolveComponent("VSpacer")!
  const _component_VDecimal = _resolveComponent("VDecimal")!

  return (_ctx.stationId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                  key: 0,
                  title: _ctx.errorMessage,
                  text: _ctx.errorText,
                  class: "my-4"
                }, null, 8, ["title", "text"]))
              : _createCommentVNode("", true),
            (_ctx.isRequestInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : (_ctx.content)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.isLinkEnabled)
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 0,
                          to: { name: 'admin/azs/station', params: { stationId: _ctx.stationId } }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.content.name), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createElementBlock("strong", _hoisted_7, _toDisplayString(_ctx.content.name), 1)),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.content.address), 1),
                    (_ctx.content.prices.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _hoisted_9,
                          _createElementVNode("ul", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.prices, (price) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: price.fuel.code,
                                class: "d-flex"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(price.fuel.code), 1),
                                _createVNode(_component_VSpacer),
                                _createVNode(_component_VDecimal, {
                                  value: price.price,
                                  class: "ml-2"
                                }, null, 8, ["value"]),
                                _createTextVNode("₽ ")
                              ]))
                            }), 128))
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode("Станция не найдена")
                  ], 64))
          ]),
          _createElementVNode("div", {
            class: "popup-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, "×"),
          _hoisted_11
        ])
      ]))
    : _createCommentVNode("", true)
}